export const dragCoordinates = ({ monitor, component }) => {
    const hoverBoundingRect = component.getBoundingClientRect();
    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;
    // Determine mouse position
    const clientOffset = monitor.getClientOffset();
    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;
    const hoverClientX = clientOffset.x - hoverBoundingRect.left;
    return {
        hoverMiddleY,
        clientOffset,
        hoverClientY,
        hoverMiddleX,
        hoverClientX,
    };
};
let emptyImage;
export const getEmptyImage = () => {
    if (!emptyImage) {
        emptyImage = new Image();
        emptyImage.src =
            'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    }
    return emptyImage;
};
//# sourceMappingURL=DragUtils.js.map